// import { CompanyType } from "./CompaniesType"
// import { PlanType } from "./PlansType"

import { CompanyType1 } from "@/types/CompaniesType"
import { LegalPersonFormType } from "@/types/LegalPersonForm"
import { PlanOptionType, PlanType } from "@/types/PlansType"
import moment from "moment"

export enum SubscriptionStatus {
  PENDING = "PENDING",
  VALIDATED = "VALIDATED",
  SUSPENDED = "SUSPENDED",
  TRYING = "TRYING"
}

export enum SubscriptionStatus1 {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  SUSPENDED = "SUSPENDED",
}

export interface SubscriptionType {
  id: string;
  plan:  string | PlanType;// PlanType;
  company: CompanyType1 | string;
  is_deleted: boolean;
  deleted_at: null;
  chosen_options: any[];
  subscribe_at: string;
  is_active: boolean;
  status: SubscriptionStatus1
  reductions?: any;
  reduction?: ReductionType;
  addons: string[] | PlanOptionType[];
  collabos_number: number;
  payment_periodicity: number;
  start_date: string;
  balance: string;
  end_date: string;
  // status: "PENDING" | "VALIDATED" | "SUSPENDED" | "TRYING"
}

export interface ReductionType {
  apply_to: string; // total or per_collabo
  discount_type: string; // percentage or fixed
  discount_value: number;
  valid_from?: string;
  valid_until?: string;
}

export interface LightSubscriptionType {
  id: string;
  chosen_options: any[];
  subscribe_at: string;
  status: SubscriptionStatus1
  is_active: boolean;
}

export type LightSubscriptionType1 = {
  id: string
  chosen_options: any[]
  subscribe_at: string
  status: SubscriptionStatus
  is_active: boolean
}

export type SubscriptionFormType = {
  "apply_to"?: string
  "collabos_number"?: string
  discount_type?: string
  discount_value?: string
  payment_periodicity?: string
  plan?: string
  chosen_addons? : string[]
  promo_code?: string
  start_date?: string | moment.Moment
  end_date?: string | moment.Moment
  usage_limit?: string
  valid_from?: string
  valid_until?: string
  reduction? : Partial<ReductionType>
}

export const SubscriptionFormDefaultValues: SubscriptionFormType = {
  "apply_to": "",
  "collabos_number": "",
  discount_type: "PERCENTAGE",
  discount_value: "",
  payment_periodicity: "",
  plan: "",
  promo_code: "",
  start_date: "",
  usage_limit: "",
  valid_from: "",
  valid_until: ""
}